import { ViewportScroller } from '@angular/common';
import {} from '@angular/common/http';
import { ChangeDetectionStrategy, Component, EnvironmentInjector } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SessionTimeoutDialogComponent } from '@reza-ais-fe/ui/components';
import { MetaService, PageSettingsModule } from '@shared/modules/page-settings';
import { LoadingOverlayComponent, UiComponentsModule } from '@shared/ui/components';
import {
  DEFAULT_NOTIFICATION_SLOT_KEY,
  ERROR_NOTIFICATION_SLOT_KEY,
  RouteParamsService,
  setAppEnvironmentInjector,
  UIService,
} from '@shared/utils';
import { PrimeNGConfig } from 'primeng/api';
import { TimesCircleIcon } from 'primeng/icons/timescircle';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import PrimeNgTranslation from './PrimeNgTranslation';
@Component({
  selector: 'reza-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UiComponentsModule,
    RouterModule,
    PageSettingsModule,
    ToastModule,
    TimesCircleIcon,
    LoadingOverlayComponent,
    ProgressBarModule,
    SessionTimeoutDialogComponent,
  ],
})
export class AppComponent {
  ERROR_NOTIFICATION_SLOT_KEY = ERROR_NOTIFICATION_SLOT_KEY;
  DEFAULT_NOTIFICATION_SLOT_KEY = DEFAULT_NOTIFICATION_SLOT_KEY;

  loading$ = this._uiService.loading$;

  constructor(
    _router: Router,
    private _meta: MetaService,
    private _config: PrimeNGConfig,
    private _uiService: UIService,

    // private _breadcrumbsService: BreadcrumbsService,
    private _routeParamsService: RouteParamsService,
    private _vi: ViewportScroller,
    injector: EnvironmentInjector
  ) {
    this._meta.init();

    this._routeParamsService.init();

    this._config.setTranslation(PrimeNgTranslation);

    setAppEnvironmentInjector(injector);
  }
}
